import { QueryObserverBaseResult } from '@tanstack/react-query'
import { Box, Button, CircularProgress, Typography } from '@mui/material'

export interface FetchErrorMessageProps {
  isFetching: boolean
  isError: boolean
  refetch: QueryObserverBaseResult<any, any>['refetch']
}

export const FetchErrorMessage = ({
  isError,
  isFetching,
  refetch,
  children,
}: React.PropsWithChildren<FetchErrorMessageProps>): JSX.Element => {
  const handleRefetch = () => {
    refetch()
  }

  return isError ? (
    <Box maxWidth={400} margin="0 auto" py={3} mt={8}>
      <Typography variant="h4" textAlign="center" sx={{ mb: 2 }}>
        Произошла ошибка при загрузке данных
      </Typography>
      <Button onClick={handleRefetch} disabled={isFetching} fullWidth>
        {isFetching ? <CircularProgress color="inherit" size={16} /> : 'Повторить запрос'}
      </Button>
    </Box>
  ) : (
    <>{children}</>
  )
}
